export const serviceCategories = [
  { name: '生活服务', items: ['保洁', '维修安装', '搬家', '跑腿'] },
  { name: '学习成长', items: ['语言辅导', '乐器陪练', '考试辅导', '职业指导'] },
  { name: '创意制作', items: ['摄影摄像', '修图剪辑', '平面设计', '文案策划'] },
  { name: '技术服务', items: ['网站制作', '自动化脚本', '数据整理', '软件指导'] },
  { name: '健康运动', items: ['健身陪练', '球类陪练', '瑜伽指导', '康复陪练'] },
  { name: '宠物服务', items: ['宠物照看', '遛宠', '洗护预约', '训练陪伴'] },
];

export const serviceMethods = ['上门', '到店', '远程', '混合'];
export const priceModes = ['按次', '按小时', '按天', '按项目', '面议', '免费互助'];

export const services = [
  {
    id: 1,
    title: '家庭深度保洁与收纳整理',
    category: '生活服务',
    method: '上门',
    priceMode: '按次',
    price: '¥198/次起',
    area: '西湖区',
    distance: '1.8km',
    radius: 3,
    provider: '林小洁',
    rating: 4.9,
    orders: 126,
    response: '12分钟内响应',
    verified: ['基础认证', '身份认证'],
    tags: ['自带工具', '可周末', '女性服务者'],
    summary: '适合入住前后、日常深度清洁、衣柜整理和厨房油污处理。',
    description: '服务包含厨房、卫生间、卧室、客厅深度清洁，可根据房屋面积和脏污程度调整服务时长。下单前请说明房屋面积、是否有宠物、是否需要收纳整理。',
    availability: '工作日 18:00 后，周末全天',
    safety: '上门服务建议保留平台聊天记录，贵重物品请提前收纳。',
    cases: ['两居室开荒保洁', '衣柜换季整理', '厨房重油清洁'],
  },
  {
    id: 2,
    title: 'React / Node 企业网站与管理后台开发',
    category: '技术服务',
    method: '远程',
    priceMode: '按项目',
    price: '¥3000/项目起',
    area: '全城远程',
    distance: '远程',
    radius: 20,
    provider: '陈工',
    rating: 5.0,
    orders: 48,
    response: '30分钟内响应',
    verified: ['身份认证', '技能认证'],
    tags: ['可签协议', '支持部署', '可开票'],
    summary: '适合企业官网、后台系统、数据看板和小型 SaaS 原型开发。',
    description: '提供需求梳理、原型确认、前后端开发、部署上线和基础运维交接。报价依据页面数量、接口复杂度和交付周期确定。',
    availability: '工作日 20:00-23:00，周末可集中交付',
    safety: '技术项目建议明确需求范围、验收标准和源代码交付方式。',
    cases: ['CRM 管理后台', '企业官网', '订单数据看板'],
  },
  {
    id: 3,
    title: '中小学英语一对一辅导',
    category: '学习成长',
    method: '混合',
    priceMode: '按小时',
    price: '¥120/小时',
    area: '滨江区',
    distance: '4.6km',
    radius: 5,
    provider: 'Mia 老师',
    rating: 4.8,
    orders: 203,
    response: '1小时内响应',
    verified: ['身份认证', '资质认证'],
    tags: ['可试听', '线上线下', '提分规划'],
    summary: '覆盖校内同步、口语训练、考试冲刺和学习习惯培养。',
    description: '首次沟通会了解年级、教材版本、薄弱点和目标分数，之后给出学习计划。线下上课仅支持公共学习空间或家长在场。',
    availability: '周二/周四晚，周六下午',
    safety: '未成年人线下服务需监护人在场或选择公共场所。',
    cases: ['七年级同步提升', '中考语法冲刺', '口语陪练'],
  },
  {
    id: 4,
    title: '活动跟拍与短视频剪辑',
    category: '创意制作',
    method: '上门',
    priceMode: '按天',
    price: '¥800/天起',
    area: '拱墅区',
    distance: '6.2km',
    radius: 8,
    provider: '阿南影像',
    rating: 4.7,
    orders: 71,
    response: '2小时内响应',
    verified: ['基础认证', '技能认证'],
    tags: ['可加急', '设备齐全', '含精修'],
    summary: '会议、生日会、课程花絮、门店探店均可预约。',
    description: '基础套餐包含半天拍摄与 1 条 60 秒短视频，额外精修照片、无人机、直播推流需单独报价。',
    availability: '需提前 2 天预约',
    safety: '拍摄前请确认场地授权和肖像使用范围。',
    cases: ['品牌沙龙跟拍', '门店宣传短片', '亲子生日会'],
  },
  {
    id: 5,
    title: '宠物上门喂养与遛宠',
    category: '宠物服务',
    method: '上门',
    priceMode: '按次',
    price: '¥45/次起',
    area: '上城区',
    distance: '2.4km',
    radius: 3,
    provider: '小麦宠护',
    rating: 4.9,
    orders: 164,
    response: '20分钟内响应',
    verified: ['身份认证'],
    tags: ['照片反馈', '可寄养咨询', '节假日可约'],
    summary: '适合出差、加班、旅行期间的猫狗基础照看。',
    description: '每次服务包含换水添粮、清理猫砂/遛狗、基础陪伴和照片反馈。需要提前说明宠物性格、门禁方式和注意事项。',
    availability: '每日 8:00-21:00',
    safety: '平台仅展示大致区域，确认预约后再交换具体地址。',
    cases: ['三天猫咪喂养', '中型犬遛宠', '节假日上门照看'],
  },
  {
    id: 6,
    title: '健身陪练与入门训练计划',
    category: '健康运动',
    method: '到店',
    priceMode: '按小时',
    price: '¥150/小时',
    area: '西湖区',
    distance: '3.1km',
    radius: 5,
    provider: '周教练',
    rating: 4.8,
    orders: 92,
    response: '45分钟内响应',
    verified: ['身份认证', '资质认证'],
    tags: ['体态评估', '新手友好', '可团课'],
    summary: '适合健身新手、减脂塑形和恢复训练前的基础动作学习。',
    description: '服务包含动作评估、训练计划、器械指导和阶段复盘。不提供医疗诊断或治疗建议，特殊身体情况请先咨询医生。',
    availability: '工作日早晚，周日全天',
    safety: '健康运动类服务需如实告知身体状况，高风险动作不建议单独尝试。',
    cases: ['新手力量训练', '减脂计划', '跑步姿态调整'],
  },
];

const serviceCopy = {
  en: {
    1: {
      title: 'Home deep cleaning and closet organization',
      priceMode: 'Per visit',
      price: 'From ¥198 / visit',
      area: 'Xihu District',
      distance: '1.8 km',
      provider: 'Lin Jie',
      response: 'Responds within 12 minutes',
      verified: ['Basic verification', 'ID verified'],
      tags: ['Brings tools', 'Weekend available', 'Female provider'],
      summary: 'Good for move-in cleaning, routine deep cleaning, closet sorting, and kitchen grease removal.',
      description: 'Includes deep cleaning for kitchens, bathrooms, bedrooms, and living rooms. Service time can be adjusted by home size and cleaning difficulty. Please mention home size, pets, and storage needs before ordering.',
      availability: 'Weekdays after 18:00, all day on weekends',
      safety: 'For on-site services, keep platform chat records and put valuables away in advance.',
      cases: ['Two-bedroom move-in cleaning', 'Seasonal closet organization', 'Heavy kitchen grease cleaning'],
    },
    2: {
      title: 'React / Node company website and admin system',
      priceMode: 'Fixed project',
      price: 'From ¥3000 / project',
      area: 'Remote citywide',
      distance: 'Remote',
      provider: 'Chen',
      response: 'Responds within 30 minutes',
      verified: ['ID verified', 'Skill verified'],
      tags: ['Contract ready', 'Deployment support', 'Invoice available'],
      summary: 'Best for company websites, admin systems, dashboards, and small SaaS prototypes.',
      description: 'Covers requirement planning, prototype confirmation, frontend and backend development, deployment, and basic handoff. Pricing depends on page count, API complexity, and delivery timeline.',
      availability: 'Weekdays 20:00-23:00, focused delivery on weekends',
      safety: 'For technical projects, define scope, acceptance criteria, and source-code handoff clearly.',
      cases: ['CRM admin system', 'Company website', 'Order analytics dashboard'],
    },
    3: {
      title: 'One-on-one English tutoring for K-12 students',
      priceMode: 'Hourly',
      price: '¥120 / hour',
      area: 'Binjiang District',
      distance: '4.6 km',
      provider: 'Mia',
      response: 'Responds within 1 hour',
      verified: ['ID verified', 'Qualification verified'],
      tags: ['Trial lesson', 'Online/offline', 'Score plan'],
      summary: 'Covers school lessons, speaking practice, exam prep, and study habits.',
      description: 'The first session reviews grade level, textbook version, weak points, and target score, then creates a study plan. Offline lessons are only supported in public study spaces or with a guardian present.',
      availability: 'Tuesday/Thursday evenings, Saturday afternoon',
      safety: 'For minors, offline services require a guardian or a public location.',
      cases: ['Grade 7 improvement', 'Grammar exam sprint', 'Speaking practice'],
    },
    4: {
      title: 'Event photography and short-video editing',
      priceMode: 'Daily',
      price: 'From ¥800 / day',
      area: 'Gongshu District',
      distance: '6.2 km',
      provider: 'Anan Studio',
      response: 'Responds within 2 hours',
      verified: ['Basic verification', 'Skill verified'],
      tags: ['Rush available', 'Full equipment', 'Retouching included'],
      summary: 'Available for meetings, birthdays, course highlights, and store promo shoots.',
      description: 'The base package includes a half-day shoot and one 60-second short video. Extra retouched photos, drone footage, and live streaming are quoted separately.',
      availability: 'Book 2 days in advance',
      safety: 'Confirm venue permissions and portrait usage rights before shooting.',
      cases: ['Brand salon coverage', 'Store promo video', 'Parent-child birthday party'],
    },
    5: {
      title: 'In-home pet feeding and dog walking',
      priceMode: 'Per visit',
      price: 'From ¥45 / visit',
      area: 'Shangcheng District',
      distance: '2.4 km',
      provider: 'Wheat Pet Care',
      response: 'Responds within 20 minutes',
      verified: ['ID verified'],
      tags: ['Photo updates', 'Boarding consultation', 'Holiday available'],
      summary: 'Basic care for cats and dogs while you travel, work late, or go on business trips.',
      description: 'Each visit includes water and food refills, litter cleaning or dog walking, basic companionship, and photo updates. Please explain pet temperament, access details, and special notes in advance.',
      availability: 'Daily 8:00-21:00',
      safety: 'The platform only shows approximate areas. Share the exact address after confirming the booking.',
      cases: ['Three-day cat feeding', 'Medium dog walking', 'Holiday home visit'],
    },
    6: {
      title: 'Fitness companion and beginner training plan',
      priceMode: 'Hourly',
      price: '¥150 / hour',
      area: 'Xihu District',
      distance: '3.1 km',
      provider: 'Coach Zhou',
      response: 'Responds within 45 minutes',
      verified: ['ID verified', 'Qualification verified'],
      tags: ['Posture assessment', 'Beginner friendly', 'Group class available'],
      summary: 'For fitness beginners, fat loss, body shaping, and learning basic movement patterns.',
      description: 'Includes movement assessment, training planning, equipment guidance, and progress review. This is not medical diagnosis or treatment advice. Please consult a doctor first for special health conditions.',
      availability: 'Weekday mornings/evenings, all day Sunday',
      safety: 'For health and fitness services, disclose physical conditions honestly and avoid high-risk movements alone.',
      cases: ['Beginner strength training', 'Fat-loss plan', 'Running posture correction'],
    },
  },
};

export function localizeService(service, language) {
  if (language !== 'en') return service;
  return { ...service, ...(serviceCopy.en[service.id] || {}) };
}

export const secondhandItems = [
  {
    id: 1,
    title: '九成新人体工学办公椅',
    category: '家具家居',
    price: '¥680',
    condition: '九成新',
    area: '西湖区',
    distance: '1.2km',
    seller: '小许',
    negotiable: true,
    summary: '居家办公使用半年，靠背和升降功能正常，可自提。',
    details: '椅子无明显破损，扶手轻微使用痕迹。建议线下验货后交易。',
  },
  {
    id: 2,
    title: '索尼降噪耳机 WH-1000XM4',
    category: '数码电子',
    price: '¥980',
    condition: '八成新',
    area: '滨江区',
    distance: '4.8km',
    seller: 'Leo',
    negotiable: true,
    summary: '功能正常，含收纳盒和充电线，耳罩已更换。',
    details: '支持现场连接测试。贵重数码建议当面检查序列号和配件。',
  },
  {
    id: 3,
    title: '儿童平衡车',
    category: '母婴儿童',
    price: '¥120',
    condition: '七成新',
    area: '上城区',
    distance: '2.7km',
    seller: '糖糖妈',
    negotiable: false,
    summary: '适合 2-4 岁儿童，轮胎正常，车身有贴纸痕迹。',
    details: '小区门口自提，介意外观使用痕迹请谨慎。',
  },
  {
    id: 4,
    title: '闲置尤克里里 23 寸',
    category: '文体乐器',
    price: '¥160',
    condition: '九成新',
    area: '拱墅区',
    distance: '5.1km',
    seller: '海盐',
    negotiable: true,
    summary: '入门练习琴，附琴包、调音器和备用弦。',
    details: '适合初学者，支持当面试音。',
  },
];
